import React, {useLayoutEffect} from 'react';
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";

const TermsOfService = () => {
  const nav = useNavigate()

  useLayoutEffect(() => {
    document.title = "Terms of Service"
  }, []);

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div className="container pb-5 d-grid">
        <Button variant='outline-primary' onClick={() => nav('/')}>Return to Homepage</Button>
      </div>
      <h1>Terms of Service</h1>
      <p><strong>Last Updated: December 5, 2025</strong></p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By entering our giveaway, you agree to these Terms of Service. If you do not agree, do not submit
        your email address.
      </p>

      <h2>2. Eligibility</h2>
      <p>To enter the giveaway, you must:</p>
      <ul>
        <li>Be at least 18 years old</li>
        <li>Be a legal resident of the United States</li>
      </ul>
      <p>
        Immediate family members of the giveaway sponsor are not eligible to participate.
      </p>

      <h2>3. How to Enter</h2>
      <p>
        To enter the giveaway, submit your email address through the form on our website. One entry per
        person per giveaway. Multiple entries from the same person will be disqualified.
      </p>

      <h2>4. No Purchase Necessary</h2>
      <p>
        No purchase or payment is required to enter or win. A purchase will not increase your chances of winning.
      </p>

      <h2>5. Giveaway Period</h2>
      <p>
        Each giveaway has a specific entry period listed on the giveaway page. Entries submitted outside
        this period will not be accepted. The entry period begins and ends at 11:59 PM EST on the dates specified.
      </p>

      <h2>6. Prize</h2>
      <p>
        Prizes vary by giveaway and are described on each giveaway page along with their approximate retail value.
        All prizes are digital codes or redemption links that will be delivered via email. No cash alternative is
        available. Prizes are awarded "as is" with no warranty or guarantee.
      </p>
      <p>
        Prize values are typically under $250. The sponsor reserves the right to substitute prizes of equal or
        greater value if the advertised prize becomes unavailable.
      </p>

      <h2>7. Winner Selection</h2>
      <p>
        Winners will be selected by random drawing within 7 days after the giveaway closes. Winners will be
        notified via email at the address provided during entry.
      </p>

      <h2>8. Odds of Winning</h2>
      <p>
        Odds of winning depend on the number of eligible entries received for each giveaway.
      </p>

      <h2>9. Winner Requirements</h2>
      <p>Winners must:</p>
      <ul>
        <li>Respond to the winner notification email within 7 days</li>
        <li>Confirm their email address and eligibility</li>
      </ul>
      <p>
        Failure to respond within the specified timeframe may result in forfeiture of the prize and selection
        of an alternate winner.
      </p>

      <h2>10. Prize Delivery</h2>
      <p>
        Digital prizes (codes, redemption links) will be sent to the winner's email address within 14 days of
        winner confirmation. The sponsor is not responsible for prizes that cannot be delivered due to incorrect
        email addresses, spam filters, or technical issues on the winner's end.
      </p>

      <h2>11. Taxes and Fees</h2>
      <p>
        Winners are responsible for any taxes associated with prize acceptance and use. Since prize values are
        under $600, no IRS Form 1099 will be issued.
      </p>

      <h2>12. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law:</p>
      <ul>
        <li>The sponsor is not responsible for technical failures, lost entries, email delivery issues, or delays</li>
        <li>The sponsor is not liable for any injuries, losses, or damages arising from participation or prize acceptance</li>
        <li>The sponsor's total liability shall not exceed the retail value of the prize</li>
        <li>Digital codes/prizes are subject to the terms and conditions of the issuing party</li>
        <li>This giveaway is operated by an individual and is not affiliated with any company or organization</li>
      </ul>

      <h2>13. Disqualification</h2>
      <p>The sponsor reserves the right to disqualify entries that:</p>
      <ul>
        <li>Violate these terms</li>
        <li>Are fraudulent, duplicate, or generated by automated means</li>
        <li>Use temporary or fake email addresses</li>
        <li>Otherwise compromise the integrity of the giveaway</li>
      </ul>

      <h2>14. Publicity Rights</h2>
      <p>
        By entering, you grant the sponsor permission to use your first name and state for winner announcement
        purposes. The sponsor will not use your full name, email address, or other personal information without
        your express written consent.
      </p>

      <h2>15. Funding and Prize Source</h2>
      <p>
        This giveaway is a personal project run by an individual passionate about STEM education. Giveaway prizes
        are funded through voluntary donations received via Ko-fi and personal contributions from the sponsor.
        Donations are applied first to website operational costs (hosting, domain, maintenance), with
        remaining funds allocated to giveaway prizes.
      </p>
      <p>
        The sponsor makes no guarantee regarding the frequency, value, or availability of future giveaways, as
        these depend on donation levels and available personal funds. This is not a commercial operation.
      </p>

      <h2>16. Modification and Cancellation</h2>
      <p>
        The sponsor reserves the right to modify, suspend, or cancel any giveaway if fraud, technical failures,
        or any other factor beyond reasonable control impairs the integrity of the giveaway. The sponsor may also
        modify these Terms at any time by posting updated terms on this page with a new "Last Updated" date.
      </p>

      <h2>17. Disputes and Governing Law</h2>
      <p>
        These Terms are governed by the laws of Illinois, United States, without regard to conflict of law
        provisions. Any disputes shall be resolved in the courts of Madison County, IL.
      </p>

      <h2>18. Severability</h2>
      <p>
        If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will
        remain in full force and effect.
      </p>

      <h2>19. STEM Educational Focus</h2>
      <p>
        This giveaway site is dedicated to promoting STEM (Science, Technology, Engineering, and Mathematics)
        education by providing access to educational resources and materials. Prize selections are made with
        educational value in mind to support learners in their STEM journey.
      </p>

      <h2>20. Sponsor Information</h2>
      <p>
        Giveaway Sponsor: Marquel Rogers<br />
        Location: Bethalto, IL<br />
        Contact: contact@freestudy.dev
      </p>
      <p>
        For questions about these Terms or any giveaway, please email the sponsor at the address above.
      </p>
    </div>
  );
};

export default TermsOfService;
